import React from 'react';

// mobx context
// import { observer } from 'mobx-react';
import SavingCapacityStoreContext from '../../stores/SavingCapacityStore';

import { Pie } from 'react-chartjs-2';

import { colorPalette } from '../../utils/Constants';

const options = {
  legend: {
    display: true,
    position: 'bottom',
  },
  tooltips: {
    callbacks: {
      label: function(tooltipItems, data) {
        return (
          data.labels[tooltipItems.index] +
          ': $' +
          data.datasets[0].data[tooltipItems.index]
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        );
      },
    },
  },
};

const GraphIncomeExpense = ({ lang }) => {
  const savingStore = React.useContext(SavingCapacityStoreContext);

  const annualIncome = savingStore.incomes > 0 ? (savingStore.incomes * 12).toFixed(2) : 0;
  const annualExpense = savingStore.expenses > 0 ? (savingStore.expenses * 12).toFixed(2) : 0;

  const data = {
    labels: [lang.incomeAnnual, lang.expenseByYear],
    datasets: [
      {
        data: [annualIncome, annualExpense],
        backgroundColor: colorPalette.savingCapacity.backgroundColor, // ['#FF6384', '#36A2EB'],
        hoverBackgroundColor: colorPalette.savingCapacity.hoverBackgroundColor, // ['#FF6384', '#36A2EB'],
      },
    ],
  };

  return <Pie data={data} options={options} />;
};

export default GraphIncomeExpense;
